
import { SEO } from '../../utils/seo';
import HeroSection from './components/HeroSection';
import IntroSection from './components/IntroSection';
import WhatIsForeclosureSection from './components/WhatIsForeclosureSection';
import TimelineSection from './components/TimelineSection';
import ConsequencesSection from './components/ConsequencesSection';
import WarningSignsSection from './components/WarningSignsSection';
import HowWeHelpSection from './components/HowWeHelpSection';
import ProcessSection from './components/ProcessSection';
import AlternativesSection from './components/AlternativesSection';
import BenefitsSection from './components/BenefitsSection';
import SuccessStoriesSection from './components/SuccessStoriesSection';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';
import Footer from '../../components/feature/Footer';
import GlobalNavbar from '../../components/feature/GlobalNavbar';

export default function AvoidForeclosurePage() {
  return (
    <div className="min-h-screen bg-white">
      <SEO
        title="Avoid Foreclosure El Paso | Sell Your House Fast to Stop Foreclosure"
        description="Facing foreclosure in El Paso? We can help you avoid foreclosure by buying your house fast for cash. Stop the foreclosure process and protect your credit. Get a fair offer today."
        keywords="avoid foreclosure El Paso, stop foreclosure Texas, sell house before foreclosure, foreclosure help El Paso, pre-foreclosure solutions"
        canonical="/avoid-foreclosure"
        schema={{
          "@context": "https://schema.org",
          "@type": "FAQPage",
          "mainEntity": [{
            "@type": "Question",
            "name": "How can I avoid foreclosure in El Paso?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "You can avoid foreclosure by selling your house fast for cash to TREX RE LLC. We can close in as fast as 7 days, stopping the foreclosure process."
            }
          }]
        }}
      />
      <GlobalNavbar />
      <HeroSection />
      <IntroSection />
      <WhatIsForeclosureSection />
      <TimelineSection />
      <ConsequencesSection />
      <WarningSignsSection />
      <HowWeHelpSection />
      <ProcessSection />
      <AlternativesSection />
      <BenefitsSection />
      <SuccessStoriesSection />
      <FAQSection />
      <CTASection />
      <Footer />
    </div>
  );
}
